import { TFunction } from 'react-i18next';
import { ColumnsType } from 'antd/es/table';
import { IPartnerProfile } from '@/models/partners.model';
import { formatDate } from '@/utils';
import PartnerTableActions from '../PartnerTableActions/PartnerTableActions';
import { StyledBadge } from './PartnerListStyles';
import { Link } from '@/ui';
import { ROUTES } from '@/models/router.model';

type TGetPartnersTableColumns = {
  t: TFunction;
  setPartnerForDelete: (partner: IPartnerProfile) => void;
  setForStatusChange: (partner: IPartnerProfile) => void;
  setHidePartner: (partner: IPartnerProfile) => void;
  authAsPartner: (id: string) => void;
  onResendInvitation: (id: string) => void;
};

export const getPartnersTableColumns = ({
  t,
  setPartnerForDelete,
  setForStatusChange,
  setHidePartner,
  authAsPartner,
  onResendInvitation,
}: TGetPartnersTableColumns): ColumnsType<IPartnerProfile> => [
  {
    title: t('users_list_title'),
    dataIndex: 'name',
    key: 'name',
    render: (_, record) => <Link path={`${ROUTES.PARTNER_DETAILS_INDEX}/${record.id}`}>{record.title}</Link>,
  },
  {
    title: t('users_store_title'),
    dataIndex: 'store_title',
    key: 'store_title',
    render: (_, record) => <span>{record?.store?.title}</span>,
  },
  {
    title: t('users_list_join_date'),
    dataIndex: 'verified_at',
    key: 'verified_at',
    render: (verified_at) => <span>{verified_at ? formatDate(verified_at) : '-'}</span>,
  },
  {
    title: t('users_list_last_login_date'),
    dataIndex: 'last_login_at',
    key: 'last_login_at',
    render: (last_login_at) => <span>{last_login_at ? formatDate(last_login_at) : '-'}</span>,
  },
  {
    title: t('users_list_phone_number'),
    dataIndex: 'phone',
    key: 'phone',
    render: (phone) => <span>{phone}</span>,
  },
  {
    title: t('users_list_email'),
    dataIndex: 'email',
    key: 'email',
    render: (email) => <span>{email}</span>,
  },
  {
    title: t('users_list_category_manager'),
    dataIndex: 'category_manager',
    key: 'category_manager',
    render: (_, record) => <span>{record.category_manager?.full_name ?? '-'}</span>,
  },
  {
    title: t('users_list_partner_status'),
    dataIndex: 'active',
    key: 'active',
    render: (active) => (
      <StyledBadge $isActive={active}>
        {active ? t('users_list_active_badge') : t('users_list_inactive_badge')}
      </StyledBadge>
    ),
  },
  {
    title: t('users_list_visibility'),
    dataIndex: 'hidden',
    key: 'hidden',
    render: (hidden) => {
      return (
        <StyledBadge $isActive={!hidden}>
          {!hidden ? t('users_list_shown_badge') : t('users_list_hidden_badge')}
        </StyledBadge>
      );
    },
  },
  {
    title: t('users_list_actions'),
    key: 'actions',
    render: (_, record) => {
      return (
        <PartnerTableActions
          id={record.id}
          isActive={record.active}
          isVisible={!record.hidden}
          record={record}
          setPartnerForDelete={setPartnerForDelete}
          setForStatusChange={setForStatusChange}
          setHidePartner={setHidePartner}
          authAsPartner={authAsPartner}
          onResendInvitation={onResendInvitation}
        />
      );
    },
  },
];
